import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../../components/layout/PageContainer/PageContainer';
import LoginForm from '../../components/auth/LoginForm/LoginForm';
import { useAuth } from '../../hooks/useAuth';

const Login: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);
  
  return (
    <PageContainer>
      <div className="max-w-md mx-auto mt-10">
        <LoginForm />
      </div>
    </PageContainer>
  );
};

export default Login; 